<template>
  <v-container fluid>
    <v-loader v-if="isLoading" absolute />
    <h1 class="page-title font-weight-regular">
      Администратор
    </h1>
    <div class="header-section d-flex align-center justify-space-between flex-wrap">
      <v-btn to="/administrator/cashier" class="button-header" dark :ripple="false">
        <font-awesome-icon icon="cash-register" />
        Касса
      </v-btn>
      <!--  <v-btn class="button-header" dark :ripple="false">
              <font-awesome-icon icon="map-marker-alt" />
              Карта курьеров
            </v-btn>-->
      <!--      <v-btn class="button-header" dark :ripple="false">
              <font-awesome-icon icon="medal" />
              Контроль качества
            </v-btn>-->
      <v-btn to="/administrator/shift-schedule" class="button-header" dark :ripple="false">
        <font-awesome-icon icon="chart-bar" />
        График смен
      </v-btn>
      <v-btn to="/administrator/work-shift" class="button-header" dark :ripple="false">
        <font-awesome-icon icon="users" />
        Смена на сегодня
      </v-btn>
      <!--      <v-btn class="button-header" dark :ripple="false">
        <font-awesome-icon icon="trash-alt" />
        Списания
      </v-btn>-->
    </div>
    <v-row class="info-section" v-if="false">
      <v-col sm="6">
        <span class="label">Касса</span>
        <div class="cashier-section">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Test
                  </th>
                  <th class="text-left">
                    Test
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <v-col sm="6">
        <span class="label">Смена сегодня</span>
        <div class="today-shift-section">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Test
                  </th>
                  <th class="text-left">
                    Test
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
    <v-row v-show="false">
      <v-col sm="4">
        <div class="map-section">
          <img src="https://www.google.com/maps/about/images/mymaps/mymaps-desktop-16x9.png" alt="map">
        </div>
      </v-col>
      <v-col sm="4">
        <div class="courier-section">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Test
                  </th>
                  <th class="text-left">
                    Test
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
                <tr>
                  <td>Test</td>
                  <td>Test</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <v-col sm="4">
        <div class="write-off-section">
          <span class="label">Списания</span>
          <span>Выберите элемент списания:</span>
          <div class="button-group">
            <v-btn class="button" block dark :ripple="false">
              Блюдо
            </v-btn>
            <v-btn class="button" block dark :ripple="false">
              Полуфабрикат
            </v-btn>
            <v-btn class="button" block dark :ripple="false">
              Ингридиент
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import VLoader from '@/components/loader/Loader'

  export default {
    name: 'Administrator',
    components: {
      VLoader,
    },
    data () {
      return {
        isLoading: false,
      }
    },
  }
</script>

<style lang="less" scoped>
  .page-title {
    margin-bottom: 24px;
  }

  .label {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
  }

  .header-section {
    background-color: @color-secondary;
    padding: 15px 15px;
    border-radius: 10px;
    margin-bottom: 24px;

    .button-header {
      flex: 1;
      margin-right: 15px;
      height: 60px;
      font-size: 18px;
      background-color: @color-btn-grey !important;
      font-weight: 500;
      color: #000;

      svg {
        width: 20px;
        height: 20px;
        margin-right: 20px;
        .fill-svg(@color-primary);
      }

      &:last-child {
        margin-right: 0;
      }
    }
    .media-sm({
      .button-header {
        flex-basis: 100% !important;
        margin: 0 0 10px 0;
      }
    });
  }

  .info-section {}

  .cashier-section,
  .today-shift-section,
  .map-section,
  .courier-section,
  .write-off-section {
    background-color: @color-secondary;
    padding: 15px 15px;
    border-radius: 10px;
  }

  .today-shift-section {
    overflow-y: auto;

    ::v-deep {
      .v-data-table {
        width: 100%;
      }
    }
  }

  .map-section {
    img {
      width: 100%;
    }
  }

  .write-off-section {
    .label {
      margin-bottom: 10px;
      line-height: 1;
    }
    .button-group {
      margin-top: 10px;
      .button {
        font-weight: 500;
        margin-bottom: 10px;
        height: 60px;
        background-color: @color-primary !important;
        font-size: 16px;
      }
    }

  }

</style>
